import React from 'react';
import { CheckCircle2, Leaf } from 'lucide-react';
interface TrustBadgeProps {
  type: 'WIC' | 'EBT';
  size?: 'sm' | 'md';
}
export function TrustBadge({
  type,
  size = 'md'
}: TrustBadgeProps) {
  const isWIC = type === 'WIC';
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-[10px] gap-1' : 'px-2.5 py-1 text-xs gap-1.5';
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5';
  if (isWIC) {
    return <span className={`inline-flex items-center ${sizeClasses} bg-[#047857] text-white font-bold rounded-full shadow-sm`} data-id="element-231">
        <Leaf className={iconSize} data-id="element-232" />
        WIC
      </span>;
  }
  return <span className={`inline-flex items-center ${sizeClasses} bg-[#1E3A5F] text-white font-bold rounded-full shadow-sm`} data-id="element-233">
      <CheckCircle2 className={iconSize} data-id="element-234" />
      EBT
    </span>;
}